import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Text from '../text';
import { addEventLog } from 'utils/functions/eventLogFunctions';
interface TableSettingsProps {
	anchorEl: null | HTMLElement;
	onClose: () => void;
	onTabSelected: (tabIndex: number) => void; // callback prop
	userName?: string;
	siteId: number;
}

export const TABLE_SETTINGS_TABS = [
	//'Upload results',
	'Sample locations',
	'Export results',
	'Alarm settings',
	'Table columns',
	'Manage users',
];
export type TableSettingsTab = typeof TABLE_SETTINGS_TABS[number];


const TableSettings: React.FC<TableSettingsProps> = ({
	anchorEl,
	onClose,
	userName,
	onTabSelected,
	siteId
}) => {


	const handleItemClick = (index: number) => {
		addEventLog(`${TABLE_SETTINGS_TABS[index]} opened`, "Site Management", siteId, undefined);
		onTabSelected(index);
		onClose();
	};

	return (
		<Menu
			id="table-settings-dropdown"
			sx={{
				'& .MuiPaper-root': {
					width: '150px',
					maxWidth: '210px',
					minWidth: '150px',
				},
				height: 'auto',
				mt: '45px',
				padding: '8px 0px',
				borderRadius: '4px',
				'& .MuiMenuItem-root': {
					fontFamily: 'inter, sans-serif !important',
					padding: '6px 0px',
					display: 'flex',
					alignItems: 'center',
					'&:hover': {
						backgroundColor: '#F4F8F9',
					},
				},
			}}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={Boolean(anchorEl)}
			onClose={onClose}
		>
			{TABLE_SETTINGS_TABS.map((setting, index) => (
				<MenuItem
					key={setting}
					onClick={() => handleItemClick(index)} // call our handler with the index
					style={{
						height: '36px',
					}}
				>
					<div className="flex items-center">
						<Text addStyle="!text-[14px] !font-inter !text-primary-black !ml-4">
							{setting}
						</Text>
					</div>
				</MenuItem>
			))}
		</Menu>
	);
};

export default TableSettings;
